import { gql, useQuery } from "@apollo/client";
import { UserClassRoomHistoryItemDto } from "./types.ts";

const GetUserClassRoomHistoryQuery = gql`
  query getUserClassRoomHistory($userId: String!, $includeUpcoming: Boolean) {
    getUserClassRoomHistory(
      userId: $userId
      includeUpcoming: $includeUpcoming
    ) {
      classRoomId
      startUtc
      endUtc
      classRoomTimezone
      teacherId
      teacherGivenName
      teacherFamilyName
      teacherEmail
      is1on1
      userGroupId
      userGroupName
      classRoomType
      isProgressCheck
      speakingLevel
      topicName
      capacity
      participantsCount
      attendedParticipantsCount
      noShowParticipantsCount
      feedbackCount
      userNoShow
      giftedByPromo
      promoBonus {
        type
        promoIds
        planId
        lessonsCountedPerWeek
        activeFromUtc
        activeToUtc
      }
      userFeedback {
        id
        teacherId
        notes
        noShow
        participation
        targetLanguage
        differentSpeakingLevelSuggested
      }
      userReview {
        reviewedAtUtc
        reviewNotes
        generalLessonScore
        teacherClearanceScore
        teacherInvolvementScore
        teacherComfortableScore
        topicUsefulnessScore
        topicDifficultyScore
      }
      progressCheckResult {
        teacherId
        passed
        noShow
        comprehension
        vocabularyRange
        fluency
        accuracy
        recommendation
        notes
        toLevel
      }
    }
  }
`;

type QueryResult = {
  getUserClassRoomHistory: UserClassRoomHistoryItemDto[];
};

export function useUserClassRoomHistory(
  userId: string,
  { includeUpcoming = false }: { includeUpcoming?: boolean } = {},
) {
  const { data, loading, error, refetch } = useQuery<QueryResult>(
    GetUserClassRoomHistoryQuery,
    {
      fetchPolicy: "cache-and-network",
      variables: { userId, includeUpcoming },
    },
  );

  return {
    classRooms: data?.getUserClassRoomHistory ?? [],
    loading,
    error,
    refetch,
  };
}
